import React from 'react'

export const HouseSizeLIcon = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='108'
      height='66'
      viewBox='0 0 108 66'
      className='f-c-st-pri f-c-fi-whi'
      fill='none'
      {...props}>
      <path
        d='M107 26.5755H1L17.3067 7.02875H90.6901L107 26.5755Z'
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M98.4433 26.5756H9.55603V61.7327H98.4433V26.5756Z'
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M82.1242 26.5756H25.8761V64.2603H82.1242V26.5756Z'
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path d='M39.697 19.6086V7.51881L53.9984 1L68.2998 7.51881V19.6086' />
      <path
        d='M39.697 19.6086V7.51881L53.9984 1L68.2998 7.51881V19.6086'
        fill='none'
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M39.6969 31.8047H33.5649V45.1131H39.6969V31.8047Z'
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M60.6103 36.7117H47.3889V60.3142H60.6103V36.7117Z'
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M50.0525 47.7311V50.0975'
        fill='none'
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M53.9986 9.79187C55.046 9.79187 56.0506 10.208 56.7912 10.9486C57.5318 11.6892 57.9479 12.6938 57.9479 13.7412V19.6088H50.0525V13.7412C50.0525 12.6943 50.4681 11.6903 51.2081 10.9497C51.948 10.2092 52.9517 9.79272 53.9986 9.79187V9.79187Z'
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M107 60.8945H1V64.2603H107V60.8945Z'
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M25.8762 57.5317H6.1908V60.8975H25.8762V57.5317Z'
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M101.809 57.5317H82.1239V60.8975H101.809V57.5317Z'
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M74.4316 31.8047H68.2997V45.1131H74.4316V31.8047Z'
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M93.3498 31.8047H87.2179V50.0973H93.3498V31.8047Z'
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M20.7821 31.8047H14.6501V50.0973H20.7821V31.8047Z'
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  )
}
